module.exports = __webpack_public_path__ + "static/media/IMG_20190816_200343.0bb3871e.jpg";